import MIcon from './src/icon.vue';

/* istanbul ignore next */
MIcon.install = function(Vue) {
  Vue.component(MIcon.name, MIcon);
};

export default MIcon;
